


 const Inputs = [

  [
    {
      type: 'text',
      name: 'email',
      placeholder: { ar:"ادخل البريد الاكتروني ", en:"Enter your email"},
      style: {ar:"color: 'green'"},
      icon: "fa fa-user",
      size: { lg: "12", md: "12" },
      loginBool: "true",
     
      
    },
    {
      type: 'password',
      name: 'password',
      placeholder: { ar:"ادخل كلمة المرور ", en:"Enter your password"},
      icon: "fa fa-lock",
      size: { lg: "12", md: "12" },
      loginBool: "true"

    }
  ]

]


export default Inputs;


